import localStorageHelper from './localStorageHelper'
import localStorageIds from '../constants/localStorageIds'
import ORGANISATION_TYPES from '../constants/OrganisationTypes'

// If i have only one team i redirect to team level
// And also based if i want to redirect to a new organisation
const redirectToHomeHelper = (teams, redirect, orgToRedirect) => {
  const { removeLocalStorageValue, setLocalStorageValue } = localStorageHelper(
    localStorageIds.SELECTED_TEAM,
  )

  if (
    teams?.length === 1 &&
    (orgToRedirect?.type !== ORGANISATION_TYPES.ORG_COMPETITION &&
      orgToRedirect?.type !== ORGANISATION_TYPES.ORG_FEDERATION)
  ) {
    setLocalStorageValue(teams[0])
    if (orgToRedirect) {
      redirect(
        '/teamCalendar',
        [{ org: orgToRedirect?.id }, { team: teams[0].id }],
        ['stage', 'group'],
      )
    } else {
      redirect('/teamCalendar', [{ team: teams[0]?.id }], ['stage', 'group'])
    }
  } else {
    removeLocalStorageValue()
    if (orgToRedirect) {
      redirect(
        '/calendar',
        [{ org: orgToRedirect?.id }],
        ['team', 'practicePlayersId', 'eventId', 'playerId', 'stage', 'group'],
      )
    } else {
      redirect(
        '/calendar',
        [],
        ['team', 'practicePlayersId', 'eventId', 'playerId', 'stage', 'group'],
      )
    }
  }
}

export default redirectToHomeHelper
